import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { DateService } from "@app/services/date.service";
import { TranslationService } from "@services/translation.service";
import "./active-range-bar-chart.component.scss";

@Component({
    selector: "active-range-bar-chart",
    template: require("./active-range-bar-chart.component.html")
})
export class ActiveRangeBarChartComponent implements OnInit, OnChanges {

    // bindings
    @Input() startMinuteOfDay: number;
    @Input() endMinuteOfDay: number;

    @Input() subject: string;

    // style
    isMiddleInclusive: boolean;

    leftSectionStart: number;
    leftSectionWidth: number;

    rightSectionStart: number;
    rightSectionWidth: number;

    rangeDescriptorHtml: string;

    constructor(
        private readonly dateService: DateService,
        private readonly translationService: TranslationService
    ) { }

    ngOnInit(): void {
        this.process();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.process();
    }

    // ---

    private process(): void {
        this.isMiddleInclusive = this.startMinuteOfDay < this.endMinuteOfDay;

        if (this.isMiddleInclusive) {
            this.leftSectionStart = this.getPercentageOfDayFromMinute(this.startMinuteOfDay);
            this.leftSectionWidth = this.getPercentageOfDayFromMinute(this.endMinuteOfDay - this.startMinuteOfDay);

            this.rightSectionStart = 0;
            this.rightSectionWidth = 0;
        }
        else {
            this.leftSectionStart = 0;
            this.leftSectionWidth = this.getPercentageOfDayFromMinute(this.endMinuteOfDay);

            this.rightSectionStart = this.getPercentageOfDayFromMinute(this.startMinuteOfDay);
            this.rightSectionWidth = 100 - this.getPercentageOfDayFromMinute(this.startMinuteOfDay);
        }

        this.updateRangeDescriptor();
    }

    private getPercentageOfDayFromMinute(minuteOfDay: number): number {
        return Math.ceil((minuteOfDay / 1440) * 100);
    }

    private updateRangeDescriptor(): void {
        const leadingVocabulary = this.translationService.t(`ActiveRangeBarChart.LeadingVocabulary`, this.subject);
        const startTimeString = this.getMinuteOfDayToTime(this.startMinuteOfDay);
        const endTimeString = this.getMinuteOfDayToTime(this.endMinuteOfDay);

        let firstRange: string = ``;
        let secondRange: string = ``;

        if (this.isMiddleInclusive) {
            firstRange = this.translationService.t(`ActiveRangeBarChart.XToY2`, [startTimeString, endTimeString]);
        } else {
            firstRange = this.translationService.t(`ActiveRangeBarChart.MidnightToX`, endTimeString);
            secondRange = this.translationService.t(`ActiveRangeBarChart.AndXToMidnight`, startTimeString);
        }

        const dateString = `(${this.dateService.getUTCOffsetLabel()} ${this.dateService.getLocalTimezone()})`;

        this.rangeDescriptorHtml = `${leadingVocabulary} ${firstRange} ${secondRange} ${dateString}`;
    }

    private getMinuteOfDayToTime(minuteOfDay: number): string {
        const minuteOfDayNumber: number = Number(minuteOfDay);

        const hour = Math.floor(minuteOfDayNumber / 60);
        const minute = Math.floor(minuteOfDayNumber % 60);

        const hourString = (hour < 10) ? `0${hour}` : `${hour}`;
        const minuteString = (minute < 10) ? `0${minute}` : `${minute}`;

        return `${hourString}:${minuteString}`;
    }
}
